import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import DropdownDialogWithPointerWrapper from '../../../../components/DropdownDialogWithPointerWrapper'
import LimitedFunctionalityDialog from './LimitedFunctionalityDialog'
import {connect} from '../../../../redux/utils'
import {getMaxFreeUsers, getUnavailableInFreeFeatures} from '../../selectors'

class FreeChooserCard extends TemplateView {
    constructor({
        onGetLicenseButtonClick = () => {},
    } = {}) {
        super()

        this.state = {
            maxFreeUsers: 0,
            unavailableInFreeFeatures: [],
        }

        this.actions = {
            onGetLicenseButtonClick
        }

        this.onStatePropertyChanged('maxFreeUsers', (maxFreeUsers) => {
            this.$usersInputsTitle.text(messageResource.getMessage('licenses.chooser.max_users_free', [maxFreeUsers]))
        })

        this.onStatePropertyChanged('unavailableInFreeFeatures', (unavailableInFreeFeatures) => {
            this.limitedFunctionalityDialog.setState({unavailableInFreeFeatures})
            this.getEl().toggleClass('noLimitations', !this.state.unavailableInFreeFeatures.length > 0)
        })
    }

    templateHtml() {
        return '<div class="container">' +
               '    <div class="title"><%=title%></div>' +
               '    <div class="userCounts">' +
               '        <div class="usersInputsTitle"/>' +
               '        <div class="noteUnlimited">' +
               '            <div class="img"/>' +
               '            <div class="note"><%=note%></div>' +
               '        </div>' +
               '    </div>' +
               '    <div class="pricing">' +
               '        <div class="price"><%=free%></div>' +
               '        <div class="pricePerMonth"><%=forever%></div>' +
               '    </div>' +
               '    <div class="purchaseButton"><span><%=purchaseButtonText%></span></div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'licenses.chooser.card_free_title',
            purchaseButtonText: 'licenses.chooser.button_free_text',
            free: 'licenses.chooser.free',
            forever: 'licenses.chooser.forever',
            note: 'licenses.chooser.limited_functionality',
        }
    }

    afterRender() {
        this.find('.purchaseButton').click(this.actions.onGetLicenseButtonClick)
        this.$usersInputsTitle = this.find('.usersInputsTitle')

        this.limitedFunctionalityDialog = new DropdownDialogWithPointerWrapper({
            additionalClass: 'limitedFunctionalityDialogWrapper',
            dialogOffsets: {left: 15, top: 0},
            dialog: new LimitedFunctionalityDialog(),
        }).init(this.getEl())

        this.$unlimitedNote = this.find('.noteUnlimited')
        this.$unlimitedNote.on('click', () => {
            if (this.state.unavailableInFreeFeatures.length > 0)
                this.limitedFunctionalityDialog.showAt(this.$unlimitedNote, {
                    my: 'left center',
                    at: 'right center',
                    collision: 'none',
                })
        })
    }
}

export default connect(
    (state) => ({
        maxFreeUsers: getMaxFreeUsers(state),
        unavailableInFreeFeatures: getUnavailableInFreeFeatures(state),
    }),
    (dispatch) => ({})
)(FreeChooserCard)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/FreeChooserCard.js